import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { AddToCartContext } from './AddToCartContext';
import CartItem from './CartItem';

import './CartDropdown.css'
import CartDropdownFooter from './CartDropdownFooter';
import CartDropdownFooterText from './CartDropdownFooterText';
import StoreHours from '../StoreHours/StoreHours';
import CallToOrder from '../buttons/CallToOrder/CallToOrder';
import EmailButton from '../buttons/EmailButton/EmailButton';

const CartDropdown = ({ showDropdown, menuTextFontStyle, wishlistFontStyle }) => {
    const { cartList, pricePrefix, removeFromCart } = useContext(AddToCartContext);

    const renderCartItems = () => {
        return (
            <div className='cart-dropdown-item-container'>
                {cartList.map((item, index) => {
                    return (
                        <CartItem
                            key={index}
                            name={item.TITLE}
                            price={item.PRICE}
                            sku={item.SKU}
                            prefix={pricePrefix}
                            url={item.PDP_URL}
                            thumbnail={item.DOWNSIZED_THUMBNAIL}
                            menuTextFontStyle={menuTextFontStyle}
                            removeFromCart={removeFromCart}
                        />
                    )
                })}
            </div>
        );
    }

    if (!showDropdown) {
        return (<div />);
    }
    return (
        <React.Fragment>
            <div id='add-to-cart-arrow' />
            <div id='add-to-cart-menu'>
                {renderCartItems()}
                {cartList.length !== 0 && <CartDropdownFooter />}
                {cartList.length !== 0 && wishlistFontStyle.text && <CartDropdownFooterText wishlistFontStyle={wishlistFontStyle} />}

                <CallToOrder className="dark-bg" isCentered={true} />
                <EmailButton />
                <StoreHours color="#464643" storeHoursStyling={{ padding: '0 20px 20px' }} fontSize='9px' />
            </div>
        </React.Fragment>
    );
}

CartDropdown.propTypes = {
    showMenu: PropTypes.bool,
    linkedStores: PropTypes.array,
    currentStoreIndex: PropTypes.number,
    menuTextFontStyle: PropTypes.object,
    menuTitle: PropTypes.string,
    sceneIdNameDict: PropTypes.object,
};

export default CartDropdown;
